/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, Title, Tip } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/area/area_styles';



/* ========== ~~~~~~~~~~ REPORT AREA ~~~~~~~~~~ ========== */
const ReportDetailArea = (props) => {
    return(
        <div className={`area ${props.name} ${props.classes.area} ${props.klass}`}>
			<Copy>
                <Title variant={`withtip`}>
                    <h2>{props.title}</h2>
                    {props.tooltip ? <Tip space={`left`} content={props.tooltip} /> : null}
                </Title>
            </Copy>
            <div className={`settings`}>
            	{props.children}
            </div>
        </div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportDetailArea);
